import { useId } from 'react'
import './FeatureSwitch.css'

/**
 * A page-level feature toggle — `تفعيل خاصية …`.
 *
 * This is a system setting, not a view filter, so it lives in the page header and
 * looks nothing like the selects in the control strip below it. The legacy mixes the
 * two into the same table toolbar, where a settings switch and a filter read alike.
 */
export default function FeatureSwitch({ checked, onChange, label, id }) {
  const generated = useId()
  const inputId = id ?? generated

  return (
    <label className={`feature-switch${checked ? ' is-on' : ''}`} htmlFor={inputId}>
      <input
        id={inputId}
        type="checkbox"
        role="switch"
        className="feature-switch__input"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span className="feature-switch__track" aria-hidden="true">
        <span className="feature-switch__thumb" />
      </span>
      <span className="feature-switch__label">
        <bdi>{label}</bdi>
      </span>
    </label>
  )
}
